import { createContext, useContext } from "react";
import PocketBase from "pocketbase";

type AuthModel = PocketBase["authStore"]["record"];

interface AuthContextType {
  isAuthenticated: boolean;
  user: AuthModel;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  resetPassword: (email: string) => Promise<void>;
  sendVerificationEmail: (email: string) => Promise<void>;
  isEmailVerified: boolean;
}

export const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
